export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  {
    name: '网红翻车',
    slug: 'wanghong-fanche',
    description: '网红大V翻车实录，直播带货、人设崩塌全记录',
    icon: 'ri-alert-line',
    count: 3,
  },
  {
    name: '明星八卦',
    slug: 'mingxing-bagua',
    description: '娱乐圈明星八卦内幕，绯闻恋情一网打尽',
    icon: 'ri-star-line',
    count: 3,
  },
  {
    name: '黑料爆料',
    slug: 'heiliao-baoliao',
    description: '独家黑料深度爆料，揭开娱乐圈不为人知的秘密',
    icon: 'ri-spy-line',
    count: 3,
  },
  {
    name: '综艺热瓜',
    slug: 'zongyi-regua',
    description: '综艺节目台前幕后，选手嘉宾撕逼大战',
    icon: 'ri-tv-line',
    count: 0,
  },
  {
    name: '影视八卦',
    slug: 'yingshi-bagua',
    description: '电影电视剧拍摄花絮，幕后八卦趣事',
    icon: 'ri-film-line',
    count: 0,
  },
  {
    name: '音乐圈瓜',
    slug: 'yinle-quangua',
    description: '音乐圈最新八卦，歌手内幕大揭秘',
    icon: 'ri-music-line',
    count: 0,
  },
];

export const getCategoryBySlug = (slug: string): Category | undefined => {
  return categories.find((c) => c.slug === slug);
};